import { NextRequest } from "next/server";
import { publishHandler } from "@/lib/article-handlers";

export const runtime = "nodejs";

export async function POST(
  req: NextRequest,
  { params }: { params: Promise<{ id: string }> },
) {
  const { id } = await params;
  return publishHandler(req, id);
}
